<template>
  <v-sheet color="primary" dark class="pa-2 px-4 mb-3 rounded" v-if="value >0">
    Вы можете снова отправить через 00:{{value.length === 1 ? `0${value}` : value}}
  </v-sheet>
</template>

<script>
  export default {
    name: 'time-interval',
    props: {

      value: {
        type: Number
      },
      delay: {
        type: Number,
        default: 59
      }
    },
    data() {
      return {
        interval: null,
      }
    },
    methods: {
      setTime() {
        this.$emit('input', this.delay)
        if(this.interval) {
          this.clearTime()
        }
        this.interval = setInterval(() => {
          this.$emit('input', this.value - 1)
          if (this.value === 0) {
            this.clearTime()
          }
        }, 1000);
      },
      clearTime() {
        clearInterval(this.interval)
        this.interval = null
      },
    },
    beforeDestroy() {
      this.clearTime()
    }
  }
</script>